import React from 'react';
import { StyledMessage, StyledIcon } from './index.styles.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
export const FormMessage = ({ text, id, variant, className, disabled, ...rest }) => {
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    return (React.createElement(StyledMessage, { ...a11yProps, ...dataProps, variant: variant, className: className, id: id, disabled: disabled },
        variant === 'error' && React.createElement(StyledIcon, { name: "caution", size: "xs" }),
        text));
};
//# sourceMappingURL=index.js.map